import { StatusRating } from 'utilities/status/status-rating.js';
import variables from 'styles/base/variables.module.scss';

export type MarkerOptions = {
  border?: string;
  background?: string;
  text?: string;
};

export type MarkerOptionsMap = Record<string, MarkerOptions>;

export const getMarkerV2ThemedPill = ({
  tags,
  status,
  markerThemes,
  defaultTheme,
}: {
  tags?: string[];
  status?: StatusRating;
  markerThemes?: MarkerOptionsMap;
  defaultTheme?: Partial<MarkerOptions>;
}): Pick<MarkerOptions, 'border' | 'background' | 'text'> | undefined => {
  if (tags) {
    /** check if theme is in additional themes */
    if (markerThemes && tags.length) {
      const markerThemesKeys = Object.keys(markerThemes);
      const [intersection] = tags.filter((tag) => markerThemesKeys.indexOf(tag) !== -1);
      if (intersection) {
        return { ...defaultTheme, ...markerThemes[intersection] };
      }
    }
    /** fallover to any hardcoded themes */
    if (tags.includes('status-background')) {
      if (status === StatusRating.statusBad) {
        return {
          border: variables['status-bad-text'],
          background: variables['status-bad-icon'],
          text: '#ffffff',
        };
      }
      if (status === StatusRating.statusMedium) {
        return {
          border: variables['status-medium-text'],
          background: variables['status-medium-icon'],
          text: '#ffffff',
        };
      }
      if (status === StatusRating.statusMediumGood) {
        return {
          border: variables['status-medium-good-text'],
          background: variables['status-medium-good-icon'],
          text: '#ffffff',
        };
      }
      if (status === StatusRating.statusGood) {
        return {
          border: variables['status-good-text'],
          background: variables['status-good-icon'],
          text: '#ffffff',
        };
      }
    }
    if (tags.includes('coastal-blue')) {
      return {
        border: variables['coastal'],
        background: variables['coastal'],
        text: '#ffffff',
      };
    }
    if (tags.includes('tides')) {
      return {
        border: variables['tides'],
        background: variables['tides'],
        text: '#ffffff',
      };
    }
  }
  return defaultTheme;
};
